import {CoreApi} from "src/api";

export const api = new CoreApi("/tsrpc");